import {eatClubClient} from "@globals/config/apiClient";

import {OrderResponseData, OrderTransaction} from "./interfaces";

export function cancelOrder(orderId: number): Promise<unknown> {
  return eatClubClient
    .put(`/api/v3/cancel-order/${orderId}/`)
    .catch(({response, message}) => {
      const error = {
        status: response?.status,
        message: response?.data?.message || message,
      };
      throw error;
    });
}

type UpcomingOrdersParams = {
  active?: boolean;
  get_extras?: boolean;
};

export function getUpcomingOrders(
  params?: UpcomingOrdersParams
): Promise<OrderResponseData[]> {
  return eatClubClient
    .get("/member/api/future-orders/v2/", {params})
    .then(({data}) => data);
}

export function getOrderTransaction(id: number): Promise<OrderTransaction> {
  return eatClubClient
    .get(`/resources/orders/${id}/transaction/`)
    .then(({data}) => data);
}
